import React, { useState } from "react"
import moment from "moment"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faUser,
  faExclamationCircle,
  faRedo
} from "@fortawesome/free-solid-svg-icons"
import styled from "styled-components"
import { timestampNormalizer } from "../util"
import Text from "../Text/Text"
import Image from "../Image/Image"
import File from "../File/File"
import Audio from "../Audio/Audio"
import Video from "../Video/Video"
import Payload from "../Payload/Payload"
import LiveChatPayload from "../LiveChatPayload/LiveChatPayload"
import Misc from "../Misc/Misc"
import Raw from "../Raw/Raw"

import PopperContainer from "../../Radiate/PopperContainer/PopperContainer"

const UserBubbleContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  >.raw {
    font-size: 0.9rem;
    font-family: 'Courier New', Courier, monospace;
  }
`

const UserBubbleSideContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  
  .time-display {
    padding: 0 4px;
    font-size: 0.6rem;
    color: #555;
  }

  .error-icon {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
`

const StyledPopperContainer = styled(PopperContainer)`
  .popper-dropdown {
    left: 0px !important;
  }
`
const RetryButton = styled.div`
  padding: 6px 8px;
  cursor: pointer;
  color: #626262;
  
  
  .redo-icon {
    padding-right: 4px;
  }
`



function renderMessage(message, color) {
  switch (message.type) {
    case "TEXT":
      return (<Text isUser color={color} data={message.data} />)
    case "IMAGE":
      return (<Image isUser color={color} data={message.data} />)
    case "FILE":
      return (<File isUser color={color} data={message.data} />)
    case "AUDIO":
      return (<Audio isUser color={color} data={message.data} />)
    case "VIDEO":
      return (<Video isUser color={color} data={message.data} />)
    case "MISC":
      return (<Misc isUser color={color} data={message.data} />)
    case "LIVE_CHAT_PAYLOAD":
      return (<LiveChatPayload isUser color={color} data={message.data} />)
    case "PAYLOAD":
      return (<Payload isUser color={color} data={message.data} />)
    default:
      return (<Raw data={message} />)
  }
}

const User = ({
  message,
  profilePic,
  noTimeDisplay,
  themeColor,
  error = null,
  createdAt,
  onResend = () => {},
  clientMutationId,
  ...props
}) => {
  const [showRetryButton, setShowRetryButton] = useState(false)
  if (["REFERRAL", "COMMENT"].indexOf(message.type) > -1) {
    return null
  }
  let timestamp = null
  if (timestampNormalizer(message.timestamp)) {
    timestamp = moment(timestampNormalizer(message.timestamp)).format("HH:mm")
  } else if (timestampNormalizer(createdAt)) {
    timestamp = moment(timestampNormalizer(createdAt)).format("HH:mm")
  }
  if (props.thirdParty) {
    return (
      <div
        className="row third-party"
      >
        <div className="content-info">
          <div className="profile">
            <div className="profile-icon">
              <FontAwesomeIcon
                icon={faUser}
                className="icon"
              />
            </div>
            <div className="third-party-name">{props.firstName}</div>
          </div>
          <div className="content">
            {renderMessage(message, themeColor)}
          </div>
          {noTimeDisplay ?
            null
            :
            <div className="time-display">
              {timestamp}
            </div>
          }
        </div>
      </div>
    )
  }
  return (
    <div
      className="row user"
    >
      <div className={`content-info  ${noTimeDisplay ? "noTimeDisplay" : null}`}>
        <UserBubbleSideContent>
          {error &&
            <StyledPopperContainer
              placement="left"
              onClickOutside={() => {
                setShowRetryButton(false)
              }}
              show={showRetryButton}
              display={(
                <FontAwesomeIcon
                  className="error-icon"
                  icon={faExclamationCircle}
                  onClick={() => {
                    setShowRetryButton(true)
                  }}
                />
              )}
            >
              <RetryButton
                onClick={() => {
                  onResend({
                    clientMutationId,
                    messageEvent: message
                  })
                  setShowRetryButton(false)
                }}
              >
                <FontAwesomeIcon
                  className="redo-icon"
                  icon={faRedo}
                />
                Retry
              </RetryButton>
            </StyledPopperContainer>
          }
          {noTimeDisplay ?
            null
            :
            <div className="time-display">
              {timestamp}
            </div>
          }
        </UserBubbleSideContent>
        
        <UserBubbleContent>
          {renderMessage(message, themeColor)}
        </UserBubbleContent>
      </div>
    </div>
  )
}

export default User
